var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotSure(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 168.05 145.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:rgba(255,255,255,.2);stroke-linecap:round;stroke-linejoin:round;}.cls-2,.cls-3,.cls-4{stroke:#fff;stroke-width:3px;}.cls-3{fill:url(#linear-gradient-2);}.cls-3,.cls-4{stroke-miterlimit:10;}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.53,
    y1: 129.55,
    x2: 38.25,
    y2: 129.55,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 14.99,
    y1: 139.7,
    x2: 22.78,
    y2: 139.7,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 32.89,
    cy: 129.55,
    r: 5.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 18.88,
    cy: 139.7,
    r: 3.89
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M139.2,40.01c.14-1.28,.22-2.58,.22-3.89,0-19.12-15.5-34.61-34.61-34.61-16.57,0-30.41,11.65-33.81,27.2-5.42-3.79-12.01-6.02-19.13-6.02-18.47,0-33.45,14.98-33.45,33.45,0,1.83,.15,3.62,.43,5.37-9.66,.45-17.36,8.4-17.36,18.17h0c0,10.06,8.16,18.22,18.22,18.22h5.1c2.08,13.74,13.94,24.27,28.27,24.27,8.62,0,16.35-3.82,21.59-9.86,6.35,7.28,15.68,11.89,26.1,11.89,16.25,0,29.88-11.2,33.6-26.3h3.21c16,0,28.97-12.97,28.97-28.97s-12.1-28.08-27.34-28.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M83.61,41.6c2.89,0,5.43,.55,7.62,1.64s3.91,2.66,5.16,4.7c1.25,2.04,1.87,4.46,1.87,7.26,0,3.15-.68,5.72-2.04,7.69-1.36,1.97-3.22,3.43-5.59,4.37s-5.06,1.41-8.08,1.41l-.2,5.92h-5.65l-.33-10.39h1.97c1.88,0,3.63-.12,5.22-.36,1.6-.24,3-.67,4.21-1.28,1.2-.61,2.15-1.52,2.83-2.73s1.02-2.75,1.02-4.63c0-1.67-.32-3.09-.95-4.27-.64-1.18-1.53-2.09-2.69-2.73-1.16-.64-2.6-.95-4.31-.95-2.54,0-4.57,.66-6.08,1.97s-2.27,3.22-2.27,5.72h-6.11c-.04-2.67,.54-5.01,1.74-7,1.2-2,2.89-3.55,5.06-4.67,2.17-1.12,4.7-1.67,7.59-1.67Zm-3.81,46.86c-1.23,0-2.25-.41-3.06-1.25-.81-.83-1.21-1.84-1.21-3.02s.4-2.26,1.21-3.09c.81-.83,1.83-1.25,3.06-1.25s2.18,.42,2.99,1.25c.81,.83,1.22,1.86,1.22,3.09s-.41,2.19-1.22,3.02c-.81,.83-1.81,1.25-2.99,1.25Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotSure);
export default __webpack_public_path__ + "static/media/not-sure.73efcbd94c5c7d03ba1f0072ba91beb2.svg";
export { ForwardRef as ReactComponent };